import { useState, useEffect } from "react"
import { useUpdateCompanyMutation, useDeleteCompanyMutation } from "./companiesApiSlice"
import { useNavigate, useParams } from "react-router-dom"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowAltCircleRight, faSave, faTrashCan } from "@fortawesome/free-solid-svg-icons"
import useAuth from "../../hooks/useAuth"

const EditCompanyForm = ({ company }) => {

    const {  isAdmin } = useAuth()
    const {groupId, type} = useParams()
    const [updateCompany, {
        isLoading,
        isSuccess,
        isError,
        error
    }] = useUpdateCompanyMutation()

    const [deleteCompany, {
        isSuccess: isDelSuccess,
        isError: isDelError,
        error: delerror
    }] = useDeleteCompanyMutation()

    const navigate = useNavigate()

    const [name, setName] = useState(company.name)
    const [active, setActive] = useState(company.active)

    useEffect(() => {

        if (isSuccess || isDelSuccess) {
            setName('')
            navigate(`/${type}/${groupId}/companies`)
        }

    }, [isSuccess, isDelSuccess, navigate])



    const canSave = [name].every(Boolean) && !isLoading

    const onSaveCompanyClicked = async (e) => {
        if (canSave) {
            await updateCompany({ id: company.id,name, active })
        }
    }

    const onDeleteCompanyClicked = async () => {
        await deleteCompany({ id: company.id })
    }
   

    const errClass = (isError || isDelError) ? "errmsg" : "offscreen"
    const validTitleClass = !name ? "form__input--incomplete" : ''

    const errContent = (error?.data?.message || delerror?.data?.message) ?? ''


    let deleteButton = null
    if (isAdmin) {
        deleteButton = (
            <button
                className="icon-button"
                title="Delete"
                onClick={onDeleteCompanyClicked}
            >
                <FontAwesomeIcon icon={faTrashCan} />
            </button>
        )
    }

    const content = (
        <>
            <p className={errClass}>{errContent}</p>

            <form className="form" onSubmit={e => e.preventDefault()}>
                <div className="form__title-row">
                    <h2>Edit Company </h2>
                    <div className="form__action-buttons">
                        <button
                            className="icon-button"
                            title="Save"
                            onClick={onSaveCompanyClicked}
                            disabled={!canSave}
                        >
                            <FontAwesomeIcon icon={faSave} />
                        </button>
                        {deleteButton}
                        <button
                            className="icon-button"
                            title="Back"
                            onClick={()=>{navigate(`/${type}/${groupId}/companies`)}}
                        >
                            <FontAwesomeIcon icon={faArrowAltCircleRight} />
                        </button>
                    </div>
                </div>
                <label className="form__label" htmlFor="company-name">
                    Name:</label>
                <input
                    className={`form__input ${validTitleClass}`}
                    id="company-name"
                    name="name"
                    type="text"
                    autoComplete="off"
                    value={name}
                    onChange={(e)=>setName(e.target.value)}
                />

               
                <div className="form__row">
                    <div className="form__divider">
                        <label className="form__label form__checkbox-container" htmlFor="company-active">
                            ACTIVE:
                            <input
                                className="form__checkbox"
                                id="company-active"
                                name="active"
                                type="checkbox"
                                checked={active}
                                onChange={e => setActive(prev => !prev)}
                            />
                        </label>

                       
                    </div>
                   
                </div>
            </form>
        </>
    )

    return content
}

export default EditCompanyForm